module.exports = __webpack_public_path__ + "media/images/text_message_unavailable-db79201245d880a9cfdd1ec4b609c73e.svg";